// extracted by mini-css-extract-plugin
export default {"note":"Note-module__note--c323"};